/**
 * A function which opens a popup window
 * @param  {string} url the url to open in the popup
 * @param  {string} windowName a unique name for the popup
 * @param  {integer} w the desired width of the popup
 * @param  {integer} h the desired height of the popup
 * @returns {object} an object the popup function is bound to
 */
const openpopup = (url, windowName, w, h) =>
  window.open(
    url,
    windowName,
    `menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes,width=${w},height=${h}`
  );

export default openpopup;
